// All paths are relative to env.apiBaseUrl, which already includes the
// /api/v1 prefix. Django requires trailing slashes — keep them on every entry.
export const ENDPOINTS = {
  auth: {
    login: '/accounts/auth/login/',
    logout: '/accounts/auth/logout/',
    refresh: '/accounts/auth/token/refresh/',
    register: '/accounts/auth/registration/',
    verifyEmail: '/accounts/auth/registration/verify-email/',
    resendVerification: '/accounts/auth/registration/resend-email/',
    passwordReset: '/accounts/auth/password/reset/',
    passwordResetConfirm: '/accounts/auth/password/reset/confirm/',
    passwordChange: '/accounts/auth/password/change/',
    google: '/accounts/auth/google/',
  },
  me: {
    detail: '/accounts/me/',
    loginActivity: '/accounts/me/login-activity/',
    completeOnboarding: '/accounts/me/complete-onboarding/',
    export: '/accounts/me/export/',
  },
  aliases: {
    list: '/aliases/',
    create: '/aliases/',
    domains: '/aliases/domains/',
    byId: (id: string) => `/aliases/${id}/`,
    toggle: (id: string) => `/aliases/${id}/toggle/`,
    regenerate: (id: string) => `/aliases/${id}/regenerate/`,
  },
  forwarding: {
    logs: '/forwarding/logs/',
    senders: '/forwarding/senders/',
    senderBlocks: '/forwarding/sender-blocks/',
    senderBlockById: (id: string) => `/forwarding/sender-blocks/${id}/`,
  },
  billing: {
    plans: '/billing/plans/',
    subscriptionMe: '/billing/subscriptions/me/',
    checkoutSession: '/billing/subscriptions/checkout-session/',
    confirmCheckout: '/billing/subscriptions/confirm-checkout/',
    changePlan: '/billing/subscriptions/change-plan/',
    cancel: '/billing/subscriptions/cancel/',
    resume: '/billing/subscriptions/resume/',
    portalSession: '/billing/subscriptions/portal-session/',
    invoices: '/billing/subscriptions/invoices/',
  },
  dashboard: {
    summary: '/dashboard/summary/',
  },
} as const;
